<template>
    <v-container class="d-flex justify-center align-center text-h5" style="min-height: 300px;">
        <div class="item item-break">
            Angaben gemäß §5 TMG:<br />
            Jaqueline Ereth<br />
            Bechhauser Weg 26<br />
            42799 Leichlingen
        </div>
        <div class="item item-break">
            Kontakt:<br />
            Mobil: +49 (0)1578 5841592<br />
            E-Mail: <a
                href="mailto:&#105;&#110;&#102;&#111;&#064;&#106;&#111;&#107;&#105;&#110;&#103;&#104;&#101;&#114;&#111;&#101;&#115;&#046;&#100;&#101;">&#105;&#110;&#102;&#111;&#064;&#106;&#111;&#107;&#105;&#110;&#103;&#104;&#101;&#114;&#111;&#101;&#115;&#046;&#100;&#101;</a>
        </div>
        <div class="item item-break">
            Verantwortlich für den Inhalt nach §55 RStV:<br />
            Jan-Niklas Ereth<br />
            Bechhauser Weg 26<br />
            42799 Leichlingen
        </div>
    </v-container>
</template>


<style scoped>
.d-flex {
    flex-wrap: wrap;
    /* Enforce line break */
}

.item {
    flex: 0 0 auto;
    /* Let items shrink and grow, but not wrap */
    margin: 0 10px;
    /* Add margin between items */
}

.item-break {
    flex-basis: 100%;
    /* Force line break after this element */
    padding-top: 2em;
}</style>